<div class="card" [ngClass]="{ 'pb-0': order.items.length > 0 }">
  @if (canCreateOrEdit && order.status?.id !== 'bill') {
    <div class="row">
      <div class="col-12 col-md-3 align-self-center">
        <h3 class="card-title">
          {{ 'products' | translate }}
        </h3>
      </div>
      <div class="col-12 col-md-9">
        <modal-product-choose
          [orderCurrency]="order.currency"
          [checkout]="order.checkout"
          [currency]="order.currency"
          [currencyDate]="order.dateCreated"
          [depots]="depots"
          [orderItems]="order.items"
          (chosenProduct)="addProductToOrder($event)"
          (chosenOrderItem)="addOrderItemToOrder($event)"
          [dataCyAttribute]="'product-choose'"
        ></modal-product-choose>
        <modal-order-item
          [isCreating]="true"
          [vats]="vats"
          [currency]="order.currency"
          [canEditPrice]="canEditPrice"
          [canCreateOrEdit]="canCreateOrEdit"
          (createdOrderItem)="createOrderItem($event)"
          [dataCyAttribute]="'product-add'"
        ></modal-order-item>
        @if (canCreateOrEdit) {
          <app-modal-order-items-sale
            [orderItems]="order.items"
            [canEditPrice]="canEditPrice"
            [canCreateOrEdit]="canCreateOrEdit"
            (orderItemsEdited)="orderItemsEdited($event)"
          >
          </app-modal-order-items-sale>
        }
      </div>
    </div>
  }
  @if (canCreateOrEdit && order.status?.id !== 'bill') {
    <div class="expedition-group">
      <div class="btn-group">
        <label
          class="btn btn-primary"
          [ngModel]="!isShowingClearanceItems"
          (ngModelChange)="isShowingClearanceItems = false"
          btnCheckbox
          tabindex="0"
          role="button"
          data-cy="order-items"
          >{{ 'order.items' | translate }}
        </label>
        @if (!isCreating) {
          <label
            class="btn btn-primary ms-2"
            [ngModel]="isShowingClearanceItems"
            (ngModelChange)="showClearanceItems()"
            btnCheckbox
            tabindex="0"
            role="button"
            data-cy="items-for-expedition"
            >{{ 'order.expedition' | translate }}</label
          >
        }
      </div>
    </div>
  }
  @if (!isShowingClearanceItems) {
    <div class="table-responsive">
      <table class="table">
        <loading-spinner [isLoading]="loading"></loading-spinner>
        @if (!loading && order.items.length === 0) {
          <thead>
            <tr>
              <th class="text-center card-subheading">{{ 'no.items' | translate }}</th>
            </tr>
          </thead>
        }
        @if (!loading && order.items.length > 0) {
          <thead>
            <tr>
              <th>
                <form-row-checkbox
                  [title]="'select.all' | translate"
                  [isInOrderProducts]="true"
                  [model]="areAllItemsChecked"
                  (modelChange)="allItemsChecked($event)"
                  [dataCySelector]="'check-all-order-items'"
                >
                </form-row-checkbox>
              </th>
              <th class="text-start padding-th-checkbox align-items-center">
                <span class="ms-5">{{ 'product.name' | translate }}</span>
              </th>
              @if (isSomeSale()) {
                <th class="text-end">{{ 'bill.sale' | translate }}</th>
              }
              <th class="text-end">{{ 'bill.vatrate' | translate }}</th>
              <th class="white-space-no-wrap text-end">{{ 'bill.price.with.vat' | translate }}</th>
              <th
                class="text-end"
                [ngClass]="
                  isCreating || (canCreateOrEdit && order.status?.id === 'reservation')
                    ? 'quantity-amount-sum-with-margin'
                    : ''
                "
              >
                {{ 'bill.qty' | translate }}
              </th>
              <th class="white-space-no-wrap text-end">{{ 'bill.total.with.vat' | translate }}</th>
              @if (canCreateOrEdit) {
                <th></th>
              }
            </tr>
          </thead>
        }
        @if (!loading) {
          <tbody class="images" data-cy="order-products" [photoGalleryGroup]="{ index: 1 }">
            @for (oItem of order.items; track oItem) {
              <tr>
                <td>
                  <form-row-checkbox
                    [isInOrderProducts]="true"
                    [title]="'select' | translate"
                    [model]="isItemRowChecked(oItem.id)"
                    (modelChange)="itemChecked($event, oItem)"
                  >
                  </form-row-checkbox>
                </td>
                @if (oItem.product) {
                  <td>
                    <div class="flex-direction-column-gap-5">
                      <div class="flex-gap-10 align-items-center">
                        <div
                          [photoGallery]="oItem.product?.mainImage?.url"
                          [photoGalleryCaption]="
                            oItem.product
                              ? oItem.product.fullName +
                                '<br>' +
                                (oItem.product.code ? ('product.code' | translate) + oItem.product.code : '') +
                                '<br>' +
                                (oItem.product.ean ? ' EAN: ' + oItem.product.ean : '')
                              : ''
                          "
                        >
                          <div class="images-item">
                            @if (
                              !!oItem.product.mainImage?.url?.length && !!oItem.product.mainImage?.thumbnails?.length
                            ) {
                              <img
                                class="images-item-image"
                                [src]="getThumbUrl(oItem.product?.mainImage)"
                                [alt]="oItem.product.fullName"
                              />
                            }
                            @if (
                              !oItem.product.mainImage?.url?.length || !oItem.product.mainImage?.thumbnails?.length
                            ) {
                              <img
                                class="images-item-image"
                                [src]="'assets/img/no-image.png'"
                                [alt]="oItem.product.fullName"
                              />
                            }
                          </div>
                        </div>
                        <div>
                          <div class="flex-gap-5">
                            <a class="link-bold" [routerLink]="['/product', oItem.product.id]" data-cy="product-link">{{
                              oItem.name
                            }}</a>
                            <!--                    todo-->
                            @if (oItem.quantityUnavailable > 0) {
                              <span
                                class="badge bg-danger badge-unavail align-self-center"
                                title="Nedostupné položky/produkty"
                              >
                                {{
                                  (oItem.quantityUnavailable | number: '1.0-2' | replaceCommaToDot) +
                                    (oItem.product && oItem.product.quantityUnavailable > 0
                                      ? '/' + (oItem.product.quantityUnavailable | number: '1.0-2' | replaceCommaToDot)
                                      : '')
                                }}
                              </span>
                            }
                          </div>
                          <div class="product-details flex-gap-5 flex-wrap">
                            @if (oItem.code) {
                              <div>
                                {{ 'product.code' | translate }}:<span> {{ oItem.code }}</span>
                              </div>
                            }
                            @if (oItem.ean) {
                              <div>
                                {{ 'product.ean' | translate }}:<span data-cy="ean"> {{ oItem.ean }}</span>
                              </div>
                            }
                          </div>
                          @if (oItem.note && oItem.note.length) {
                            <div class="product-details">
                              <!--                    <div [innerHtml]="oItem.note | nl2br"></div>-->
                              {{ 'product.note.short' | translate }}:<span [innerHtml]="oItem.note | nl2br"></span>
                            </div>
                          }
                          <div class="product-details flex-gap-5 flex-wrap">
                            @if (oItem.serial && oItem.serial.length) {
                              <div>
                                <div [innerHtml]="oItem.serial | nl2br"></div>
                              </div>
                            }
                            @if (
                              (oItem.expirationDate && oItem.expirationDate.length > 0) ||
                              (oItem.batch && oItem.batch.length > 0)
                            ) {
                              <div>
                                <div class="ps-3">
                                  @if (oItem.expirationDate && oItem.expirationDate.length > 0) {
                                    <span>
                                      {{ ('expiration' | translate) + ':' }} {{ oItem.expirationDate }}
                                      @if (
                                        (oItem.batch && oItem.batch.length > 0) ||
                                        (oItem.position && oItem.position.length > 0 && oItem.position !== '--')
                                      ) {
                                        <span>,</span>
                                      }
                                    </span>
                                  }
                                  @if (oItem.batch && oItem.batch.length > 0) {
                                    <span>
                                      {{ ('product.batch' | translate) + ':' }}: {{ oItem.batch }}
                                      @if (oItem.position && oItem.position.length > 0 && oItem.position !== '--') {
                                        <span>,</span>
                                      }
                                    </span>
                                  }
                                  @if (oItem.position && oItem.position.length > 0 && oItem.position !== '--') {
                                    <span> {{ ('position' | translate) + ':' }}: {{ oItem.position }} </span>
                                  }
                                </div>
                              </div>
                            }
                            @if (!isCreating && (hasExpirationsOnUpdate(oItem) || hasBatchesOnUpdate(oItem))) {
                              <div>
                                @for (move of oItem.moves; track move) {
                                  <div>
                                    <div
                                      [innerHtml]="
                                        hasExpirationsOnUpdate(oItem)
                                          ? 'Expirace: ' +
                                            getProductNameForExpirationDate(move.productDepotFrom.id, oItem) +
                                            ' - ' +
                                            move.amount +
                                            'x ' +
                                            (move.productDepotFrom.expirationDate.substring(0, 10) | date: 'dd.MM.yyyy')
                                          : hasBatchesOnUpdate(oItem)
                                            ? 'Šarže: ' + move.amount + 'x ' + move.productDepotFrom.batch
                                            : null
                                      "
                                    ></div>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                          @if (isShownTagsColumn()) {
                            <td class="border-bottom-none">
                              @for (tag of oItem.product?.tags; track tag) {
                                <span
                                  class="tag-span"
                                  [ngStyle]="{ 'background-color': tag.color ? tag.color : '#0058FF', color: 'white' }"
                                >
                                  {{ tag.name }}
                                </span>
                              }
                            </td>
                          }
                        </div>
                      </div>
                      @for (bc of oItem.product.bundleChildren; track bc) {
                        <div class="ms-5">
                          <div class="flex-gap-5 align-items-center ps-3 virtual-product">
                            <i class="fas fa-angle-right"></i>
                            <div>
                              <a
                                class="link-bold"
                                [routerLink]="['/product', bc.child.id]"
                                data-cy="bundle-product-link"
                                >{{ bc.child.name }}</a
                              >
                            </div>
                          </div>
                          <div class="product-details flex-gap-5 flex-wrap ms-4">
                            @if (bc.child.code) {
                              <div>
                                {{ 'product.code' | translate }}:<span data-cy="bundle-code">{{ bc.child.code }}</span>
                              </div>
                            }
                            @if (bc.child.ean) {
                              <div>
                                {{ 'product.ean' | translate }}:<span data-cy="bundle-ean">{{ bc.child.ean }}</span>
                              </div>
                            }
                            <div>
                              •
                              <span data-cy="bundle-quantity"
                                >{{ bc.quantity | number: '1.0-2' | replaceCommaToDot }}x</span
                              >
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </td>
                }
                @if (!oItem.product) {
                  <td class="top-align ptop-11">
                    <div class="flex-gap-5">
                      <h3 class="card-subheading mb-0 padding-left-2-5">{{ oItem.name }}</h3>
                    </div>
                  </td>
                }
                @if (isSomeSale()) {
                  <td class="text-nowrap text-end top-align ptop-11">
                    <div>{{ oItem.sale > 0 ? oItem.sale + '%' : '' }}</div>
                    <div class="saleInPrice">
                      {{ '(' + (getSaleInPrice(oItem.price, oItem.sale) | formatPrice: order.currency) + ')' }}
                    </div>
                  </td>
                }
                <td class="text-nowrap text-end top-align ptop-11">{{ oItem.vat ? oItem.vat.percent : 0 }}%</td>
                <td class="text-nowrap text-end top-align ptop-11">
                  {{ (oItem ? oItem.price : 0) | formatPrice: order?.currency }}
                </td>
                <td class="text-nowrap text-end top-align ptop-11">
                  @if (isCreating || (canCreateOrEdit && order.status?.id === 'reservation')) {
                    <form-row-number-with-controls
                      class="float-right"
                      [noMarginBottom]="true"
                      [label]="null"
                      [model]="oItem.quantity"
                      [minWidthPx]="120"
                      [maxWidthPx]="120"
                      (modelChange)="changeQuantity($event, oItem)"
                    ></form-row-number-with-controls>
                  }
                  @if (!isCreating && order.status?.id === 'bill') {
                    <div>
                      {{ oItem.quantity }}
                    </div>
                  }
                </td>
                @if (!isCreating && !canCreateOrEdit) {
                  <td class="text-end top-align ptop-11">
                    <div>
                      {{ oItem.quantity | number: '1.0-2' | replaceCommaToDot }}
                    </div>
                  </td>
                }
                <td class="text-nowrap text-end top-align ptop-11">
                  {{ (oItem ? oItem.priceAll : 0) | formatPrice: order?.currency }}
                </td>
                @if (canCreateOrEdit) {
                  <td class="top-align ptop-7">
                    <div class="flex-gap-5 flex-row-reverse">
                      @if (order.status?.id !== 'bill') {
                        <btn
                          class="align-self-center"
                          [title]="'delete' | translate"
                          [icon]="'far-trash-alt'"
                          (onEvent)="removeOrderItem(oItem)"
                          [classes]="['btn-sm', 'btn-trash']"
                          [dataCyAttribute]="'deleteOrderItem-button'"
                        ></btn>
                      }
                      <modal-order-item
                        [isCreating]="false"
                        [vats]="vats"
                        [orderItem]="oItem"
                        [currency]="order.currency"
                        [canEditPrice]="canEditPrice"
                        [canEditQuantity]="order.status?.id !== 'bill'"
                        [canCreateOrEdit]="canCreateOrEdit"
                        (updatedOrderItem)="updateOrderItem($event)"
                        [dataCyAttribute]="'updateOrderItem-button'"
                      ></modal-order-item>
                    </div>
                  </td>
                }
              </tr>
            }
            @if (order.items && order.items.length > 0 && order.rounding > 0) {
              <tr>
                <th class="no-hover">&nbsp;</th>
                <th class="padding-left-2-9" style="font-weight: normal">{{ 'order.rounding' | translate }}</th>
                <td class="text-end no-hover">{{ order.items[0].vat.percent || 0 }}%</td>
                <!--          todo cena bez dane tady se neukazuje sloupec, pridat ve vyčíslení dph-->
                <!--          <td class="text-end no-hover">-->
                <!--            {{ (order.rounding * order.items[0].vat.coefficient).toFixed(2) }}-->
                <!--            {{-->
                <!--            order.currency?.id-->
                <!--              ? (order.currency.id | translate)-->
                <!--              : (core.services.user?.user?.company?.currency?.id | translate)-->
                <!--            }}-->
                <!--          </td>-->
                <!--          <td *ngIf="isSomeSale()" class="td-invisible no-hover">&nbsp;</td>-->
                <!--          <td class="td-invisible no-hover">&nbsp;</td>-->
                <!--          gtePriceAllWithVat-->
                <td class="text-end no-hover">
                  {{ order.rounding ? order.rounding?.toFixed(2) : 0.0 }}
                  {{
                    order.currency.id
                      ? (order.currency.id | translate)
                      : (core.services.user?.user?.company?.currency?.id | translate)
                  }}
                </td>
                <td class="no-hover">&nbsp;</td>
                <td class="text-end no-hover">
                  {{ order.rounding ? order.rounding?.toFixed(2) : 0.0 }}
                  {{
                    order.currency.id
                      ? (order.currency.id | translate)
                      : (core.services.user?.user?.company?.currency?.id | translate)
                  }}
                </td>
                <td colspan="2" class="no-hover">&nbsp;</td>
              </tr>
            }
            @if (!loading && order && order.items && order.items.length > 0) {
              <tr>
                <td colspan="3" class="td-invisible no-hover">
                  <app-modal-move-order-items
                    [itemsFromParent]="checkedItems"
                    [order]="order"
                    [selectedOrder]="selectedOrder"
                    (orderReload)="orderReloadEmit()"
                    (setCheckboxes)="setDefaultValues()"
                  >
                  </app-modal-move-order-items>
                </td>
                @if (isSomeSale()) {
                  <td class="td-invisible no-hover">&nbsp;</td>
                }
                <td class="card-subheading text-nowrap text-end no-hover">{{ 'bill.total' | translate }}</td>
                <td
                  class="card-subheading text-end no-hover"
                  [ngClass]="
                    isCreating || (canCreateOrEdit && order.status?.id === 'reservation')
                      ? 'quantity-amount-sum-with-margin'
                      : ''
                  "
                >
                  {{ getQuantityItemsSum() | number: '1.0-2' | replaceCommaToDot }}
                </td>
                <td class="card-subheading text-nowrap text-end no-hover" data-cy="orderItems-priceSum">
                  {{ orderItemsPriceSumHack() | formatPrice: order?.currency }}
                </td>
                @if (canCreateOrEdit) {
                  <td class="td-invisible no-hover">&nbsp;</td>
                }
              </tr>
            }
          </tbody>
        }
      </table>
    </div>
  }
  @if (isShowingClearanceItems) {
    <div class="table-responsive">
      <table class="table">
        <loading-spinner
          [isLoading]="loading"
          [spinnerOverlayAddedClass]="'custom-loading-spinner-order-products'"
        ></loading-spinner>
        @if (!loading && clearanceItems.length === 0) {
          <thead>
            <tr>
              <th colspan="5" class="text-center card-subheading">{{ 'no.items' | translate }}</th>
            </tr>
          </thead>
        }
        @if (!loading && !areClearanceItemsInSync) {
          <thead>
            <tr>
              <th colspan="5" class="text-center card-subheading bg-danger">
                {{ 'clearanceItems.not.synced' | translate }}
              </th>
            </tr>
          </thead>
        }
        @if (!loading && clearanceItems.length > 0) {
          <thead>
            <tr>
              <th class="text-start">{{ 'product.name' | translate }}</th>
              <th class="text-start">{{ 'depot' | translate }}</th>
              <th class="text-center">{{ 'depot.position' | translate }}</th>
              <th class="text-center">&nbsp;</th>
              <th class="text-end">{{ 'bill.qty' | translate }}</th>
              @if (canCreateOrEdit) {
                <th></th>
              }
            </tr>
          </thead>
        }
        @if (!loading && clearanceItems.length > 0) {
          <tbody class="images" [photoGalleryGroup]="{ index: 2 }">
            @for (cItem of clearanceItems; track cItem) {
              <tr data-cy="clearanceItems-listing">
                @if (cItem.product) {
                  <td class="ps-1">
                    <div class="flex-direction-column-gap-5">
                      <div class="flex-gap-10 align-items-center">
                        <div
                          [photoGallery]="cItem.product.mainImage?.url"
                          [photoGalleryCaption]="
                            cItem.product
                              ? cItem.product.fullName +
                                '<br>' +
                                (cItem.product.code ? ('product.code' | translate) + cItem.product.code : '') +
                                '<br>' +
                                (cItem.product.ean ? ' EAN: ' + cItem.product.ean : '')
                              : ''
                          "
                        >
                          <div class="images-item">
                            @if (
                              !!cItem.product.mainImage?.url?.length && !!cItem.product.mainImage?.thumbnails?.length
                            ) {
                              <img
                                class="images-item-image"
                                [src]="getThumbUrl(cItem.product?.mainImage)"
                                [alt]="cItem.product.fullName"
                              />
                            }
                            @if (
                              !cItem.product.mainImage?.url?.length || !cItem.product.mainImage?.thumbnails?.length
                            ) {
                              <img
                                class="images-item-image"
                                [src]="'assets/img/no-image.png'"
                                [alt]="cItem.product.fullName"
                              />
                            }
                          </div>
                        </div>
                        <div>
                          <div class="flex-gap-5">
                            <a class="link-bold" [routerLink]="['/product', cItem.product.id]">{{
                              cItem.product.fullName
                            }}</a>
                          </div>
                          <div class="product-details flex-gap-5 flex-wrap">
                            @if (cItem.product.code) {
                              <div>
                                {{ 'product.code' | translate }}:<span> {{ cItem.product.code }}</span>
                              </div>
                            }
                            @if (cItem.product.ean) {
                              <div>
                                {{ 'product.ean' | translate }}:<span> {{ cItem.product.ean }}</span>
                              </div>
                            }
                            @if (cItem.batch && cItem.batch.length > 0) {
                              <div>
                                {{ 'product.batch' | translate }}:<span> {{ cItem.batch }}</span>
                              </div>
                            }
                            @if (cItem.expirationDate && cItem.expirationDate.length > 0) {
                              <div>
                                {{ 'product.expirationDate' | translate }}:
                                @if (!cItem.expirationDate.includes('00:00:00')) {
                                  <span>{{ cItem.expirationDate | fmtDate: 'dd.MM.yyyy HH:mm' }}</span>
                                }
                                @if (cItem.expirationDate.includes('00:00:00')) {
                                  <span>{{ cItem.expirationDate | fmtDate: 'dd.MM.yyyy' }}</span>
                                }
                              </div>
                            }
                            @if (
                              cItem.position1?.length > 0 || cItem.position2?.length > 0 || cItem.position3?.length > 0
                            ) {
                              <div>
                                {{ 'position' | translate }}:<span> {{ cItem.position }}</span>
                              </div>
                            }
                            @if (cItem.locked) {
                              <div>
                                <i class="far fa-lock"></i>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                }
                <td class="text-nowrap text-end pe-1">
                  <div class="d-flex align-items-center text-nowrap">
                    {{ cItem?.depot?.name ? cItem.depot.name : 'no depot' }}
                  </div>
                </td>
                <td class="text-center">
                  @if (cItem.position && cItem.position !== '--') {
                    <div class="process-status-recieved text-nowrap">
                      {{ cItem.position }}
                    </div>
                  }
                </td>
                <td class="text-center">
                  @if (cItem.locked) {
                    <div>
                      <i class="far fa-lock"></i>
                    </div>
                  }
                </td>
                <td class="text-end">
                  <div>
                    {{ cItem.amount | number: '1.0-2' | replaceCommaToDot }}
                  </div>
                </td>
                @if (canCreateOrEdit) {
                  <td class="pe-1">
                    <div class="flex-gap-5 flex-row-reverse">
                      <modal-clearance-item
                        [clearanceItem]="cItem"
                        [depots]="depots"
                        [order]="order"
                        (updatedClearanceItem)="onClearanceItemsUpdate()"
                      ></modal-clearance-item>
                    </div>
                  </td>
                }
                @if (cItem.batch && cItem.batch.length > 0) {
                  <td>&nbsp;</td>
                }
              </tr>
            }
            <tr>
              <td colspan="2" class="td-invisible no-hover"></td>
              <td class="card-subheading text-center text-nowrap no-hover">{{ 'bill.total' | translate }}</td>
              <td class="card-subheading text-end no-hover">
                {{ quantityAmountSum | number: '1.0-2' | replaceCommaToDot }}
              </td>
            </tr>
          </tbody>
        }
      </table>
    </div>
  }
</div>
